import React, { useMemo } from 'react';

import { IMessageAttachment } from '@entities/message/model/types';
import { Image, UiText } from '@shared/ui';
import { useCommentsMainContext } from '@widgets/Comments/model';

import cls from './ImageAttachments.module.css';

export const ImageAttachments = ({ imgAttachments }: { imgAttachments: IMessageAttachment[] }) => {
    const { openAttachmentLightbox } = useCommentsMainContext();

    const imageCount = useMemo(() => {
        if (imgAttachments.length === 0) return null;
        if (imgAttachments.length === 1) return null;
        return imgAttachments.length - 1;
    }, [imgAttachments?.length]);

    if (imgAttachments && imgAttachments.length > 0) {
        return (
            <div
                className={cls.ImageAttachmentsContainer}
                onClick={() => openAttachmentLightbox(imgAttachments, imgAttachments[0].id)}
            >
                <Image
                    src={imgAttachments[0]?.originalUrl}
                    width="100%"
                    height={194}
                    className={cls.ImageAttachment}
                    wrapperClassName={cls.ImageWrapper}
                />
                <div className={cls.ImageAttachmentsOverlay} />
                {imageCount > 0 && (
                    <UiText variant="heading" weight="semibold" className={cls.ImageCounter}>
                        +{imageCount}
                    </UiText>
                )}
            </div>
        );
    }
    return null;
};
